const JsSupport = {
  init: function () {
    let $body = $('body');
    $body.removeClass('no-js');
  }
};
JsSupport.init();
